/**
 * Configuração centralizada de horário ativo para sistema V2.0
 *
 * IMPORTANTE: Estes valores devem estar sincronizados com o backend:
 * - Backend: src/config/settings.py
 *   - penalty_v2_active_start_hour
 *   - penalty_v2_active_end_hour
 *
 * Apenas horas no intervalo [START, END) contam para penalizações V2.0
 */

export const ACTIVE_HOURS_CONFIG = {
  /**
   * Hora de início do horário ativo (UTC)
   * @default 9 - 09:00
   */
  START: 9,

  /**
   * Hora de fim do horário ativo (UTC)
   * @default 22 - 22:00
   */
  END: 22,

  /**
   * Total de horas ativas por dia
   * Calculado automaticamente como END - START
   */
  get TOTAL_HOURS(): number {
    return this.END - this.START;
  }
} as const;

/**
 * Helper para verificar se uma hora está dentro do horário ativo
 * @param hour - Hora em formato 0-23 (UTC)
 * @returns true se está no horário ativo
 */
export function isActiveHour(hour: number): boolean {
  return hour >= ACTIVE_HOURS_CONFIG.START && hour < ACTIVE_HOURS_CONFIG.END;
}

/**
 * Helper para obter descrição textual do horário ativo
 * @returns String descritiva "9h-22h"
 */
export function getActiveHoursLabel(): string {
  return `${ACTIVE_HOURS_CONFIG.START}h-${ACTIVE_HOURS_CONFIG.END}h`;
}
